import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { TransferPrivateNumberCommand } from 'src/app/core/api/models';
import {
  OrganizationsService,
  PrivateNumbersService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';


@Component({
    selector: 'app-transfer-private-numbers-form',
    templateUrl: './transfer-private-numbers-form.component.html',
    imports: [BaseFormModule]
})
export class TransferPrivateNumberFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  pageVocabs = 'pages.numbers.form.';
  @Input('preOwner') preOwner;
  @Input('number') number;

  model: TransferPrivateNumberCommand = {};

  //#endregion

  constructor(
    protected currentService: PrivateNumbersService,
    public organizationService: OrganizationsService,
    public privateNumberService: PrivateNumbersService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.preOwner) this.preOwner = decodeURIComponent(this.preOwner);
    this.changeFormValidations();
  }

  initForm() {
    this.form = new FormGroup({
      privateNumberId: new FormControl(''),
      preOwnerId: new FormControl(''),
      newOwnerId: new FormControl('', Validators.required),
      price: new FormControl('', Validators.required),
      expireDate: new FormControl('', Validators.required),
    });
  }

  initModel(): void {
    try {
      this.model.expireDate = DateTimeService.getAYearLater();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  changeFormValidations() {
    try {
      this.form.controls['preOwnerId'].disable();
      this.form.controls['privateNumberId'].disable();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }

  //#region Api

  // //Update
  baseUpdateApi(model: TransferPrivateNumberCommand) {
    this.unSubs();

    this.loading = true;
    try {
      model.expireDate = DateTimeService.toUTC(this.model.expireDate);
      model.preOwnerId = this.formPageConfig.editData.preOwnerId;
      model.privateNumberId = this.formPageConfig.editData.privateNumberId;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }

    this.currentService
      .privateNumbersTransferPrivateNumberPost({
        body: model,
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit() {
    if (!this.isValidForm(this.form, this.tagName)) return;
    if (this.loading) return;
    this.baseUpdateApi(this.model);
  }
}
